import { APIFactory } from 'ui-toolkit/rest/APIFactory';
import { axiosErrorHandler } from 'ui-toolkit/rest/axiosErrorHandler';
import { baseUrlService } from '../../../ui-toolkit/rest/BaseUrlService';

export interface IGetActivityActionsAsyncProps {
  orderId: string;
}

export const getActivityActionsAsync = ({ orderId }: IGetActivityActionsAsyncProps) =>
  APIFactory(baseUrlService.ApiLocation)
    .get<string[]>(`/timber/api/internal/orders/${orderId}/actions`)
    .then((t) => t.data)
    .catch(axiosErrorHandler);
